import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css'

const Posthistory2 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "Renaissance Insights",
      date: "February 1, 2023",
      image: "/assets/FeedItems/BBkaMGe503fFKsePJPf.svg",
      summary: "Uncover the rebirth of knowledge, art, and scientific discovery during the Renaissance period. Learn about humanism, artistic achievements, scientific advancements, exploration, and literary contributions.",
      path: "blog/history/post/posthistory2"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "Renaissance Insights",
    date: "February 1, 2023",
    image: "/assets/FeedItems/BBkaMGe503fFKsePJPf.svg",
    summary: "Uncover the rebirth of knowledge, art, and scientific discovery during the Renaissance period. Learn about humanism, artistic achievements, scientific advancements, exploration, and literary contributions.",
    path: "blog/history/post/posthistory2"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          The Renaissance, a period of cultural, artistic, and intellectual revival, began in Italy in the 14th century and spread across Europe over the next few centuries. This era marked a departure from the medieval period and ushered in a new age of exploration, innovation, and humanism.
        </p>
        <h2>The Birth of Humanism</h2>
        <p>
          Humanism, a key intellectual movement of the Renaissance, emphasized the value of human potential and achievements. Scholars and thinkers like Petrarch and Erasmus sought to revive classical learning and texts, believing that studying the works of ancient Greece and Rome could lead to a better understanding of the human condition.
        </p>
        <h2>Artistic Achievements</h2>
        <p>
          The Renaissance produced some of the most renowned artists in history, including Leonardo da Vinci, Michelangelo, and Raphael. These artists pushed the boundaries of creativity and technique, producing masterpieces that continue to be celebrated today. Leonardo's "Mona Lisa" and "The Last Supper," Michelangelo's Sistine Chapel ceiling, and Raphael's "School of Athens" are just a few examples of the period's artistic brilliance.
        </p>
        <h2>Scientific Advancements</h2>
        <p>
          The Renaissance was also a time of significant scientific discovery and innovation. Figures like Galileo Galilei, Nicolaus Copernicus, and Johannes Kepler challenged traditional views of the cosmos and laid the groundwork for modern astronomy. Galileo's use of the telescope to observe celestial bodies, Copernicus's heliocentric theory, and Kepler's laws of planetary motion revolutionized our understanding of the universe.
        </p>
        <h2>Exploration and Expansion</h2>
        <p>
          The Renaissance era saw an increase in exploration and global expansion. Explorers like Christopher Columbus, Vasco da Gama, and Ferdinand Magellan embarked on voyages that opened up new trade routes and connected distant parts of the world. These expeditions not only brought wealth and resources to Europe but also facilitated cultural exchanges and the spread of ideas.
        </p>
        <h2>Literary Contributions</h2>
        <p>
          The Renaissance produced a wealth of literary works that continue to be studied and admired. Writers like Dante Alighieri, Geoffrey Chaucer, and William Shakespeare explored themes of human nature, love, and morality in their works. Dante's "Divine Comedy," Chaucer's "Canterbury Tales," and Shakespeare's plays and sonnets are enduring examples of the period's literary achievements.
        </p>
        <p>
          The Renaissance was a transformative period that reshaped the cultural, intellectual, and artistic landscape of Europe. Its legacy continues to influence modern thought, art, and science, reminding us of the enduring power of human creativity and curiosity.
        </p>
      </div>
    </div>
  );
};

export default Posthistory2;